import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { getNavigationStates, getNavigationStatesWithSmartHome, NavigationOptions } from '../shared/states';
import { TransitionService } from '@uirouter/angularjs';
import { CurrentUserService } from 'services/currentUser';
import { get } from 'lodash';
import { ExperimentsService } from 'services/experiments';
import { providerToExperimentFlagMap } from 'utilities/experiments';

const module = angular.module('desktop-navigation', ['ui.router']);

interface DesktopNavigationController extends angular.IStrictController {
    navigationList: NavigationOptions;
    hideNavigation: boolean;
    isSmartHomePageExperimentEnabledForProvider: (provider: string) => boolean;
}

module.component('desktopNavigation', {
    template: template,
    controller: function(
        this: DesktopNavigationController,
        $transitions: TransitionService,
        $stateParams: StateParams,
        currentUserService: CurrentUserService,
        experimentsService: ExperimentsService
    ) {
        'ngInject';

        const updateDisplay = (policyIndex?: RoutePolicyIndex, showSmartHomeNavigationLink: boolean = false): void => {
            this.hideNavigation = !policyIndex;

            if (!policyIndex) {
                policyIndex = '1' as RoutePolicyIndex;
                // any value is fine, we disable the resulting navigation anyway in this case
            }

            if (showSmartHomeNavigationLink) {
                this.navigationList = getNavigationStatesWithSmartHome(policyIndex);
            } else {
                this.navigationList = getNavigationStates(policyIndex);
            }
        };

        this.$onInit = () => {
            $transitions.onSuccess({}, (transition) => {
                const policyIndex = transition.params().policyIndex;

                if (policyIndex) {
                    currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                        // typecasting here to over come using lodash get
                        const smartHomeKits = get(policyInfo, 'smart_home.state_summary.kit_details') as Array<
                            SmartHomeKit
                        >;

                        /*
                            smart home kits are ordered by date created. The last kit should be the one the customer
                            most recently chose which will be used to render the smart home page UI.
                         */
                        const lastSmartHomeKit = smartHomeKits ? smartHomeKits[smartHomeKits.length - 1] : null;

                        const isSmartHomePageExperimentEnabledForProvider = lastSmartHomeKit
                            ? experimentsService.isExperimentEnabled(
                                  providerToExperimentFlagMap[lastSmartHomeKit.provider]
                              )
                            : false;

                        updateDisplay(policyIndex, isSmartHomePageExperimentEnabledForProvider);
                    });
                } else {
                    updateDisplay(policyIndex);
                }
            });

            updateDisplay($stateParams.policyIndex);
        };
    }
});

export { module };
